import { render, staticRenderFns } from "./AccessoryPartType.vue?vue&type=template&id=0485997a"
import script from "./AccessoryPartType.vue?vue&type=script&lang=js"
export * from "./AccessoryPartType.vue?vue&type=script&lang=js"
import style0 from "./AccessoryPartType.vue?vue&type=style&index=0&id=0485997a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports